import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import Subscribers from '../../../../Shared/GeneralPages/Subscribers/Subscribers';
import { setSelectedSubscriber , goToPage , setCustomerServiceMessageType } from '../../ConnectionDetailsBlockSlice';
import {getIspConnectionDetailsAsync} from '../../ConnectionDetailsBlockAsyncThunk';

const SubscribersPage = (props) => {
const selectedSubscriber = props.selectedSubscriberFromSelfCare || props.selectedSubscriberFromWizard;
    function handleOnSelectSubscriber(subscriber) {
        if (subscriber) {
            props.setSelectedSubscriber(subscriber);
            props.getIspConnectionDetailsAsync();
        }
        else{
            props.setCustomerServiceMessageType('SUBSCRIBER_NOT_FOUND');
            props.goToPage('customerServiceMessagesPage');
        }
    };

    return (<Subscribers saleType={'internet'} onSelectSubscriber={handleOnSelectSubscriber} selectedSubscriber={selectedSubscriber} />);

};

const mapStateToProps = (state) => {
  return {
    selectedSubscriberFromSelfCare: (state.selfcarePage?.isFetchData ? state.selfcarePage?.selectedSubscriber?.subscriberNumber : ''),
    selectedSubscriberFromWizard: state.serviceAppointmentSchedulerBlock?.subscriber?.subscriberNo ?? ''

  };
};

const mapDispatchToProps = { setSelectedSubscriber, getIspConnectionDetailsAsync , setCustomerServiceMessageType, goToPage };

export default connect(mapStateToProps, mapDispatchToProps)(SubscribersPage);
